import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  margin-top: 9px;
`;

export const Column = styled.div`
    width: 50%;
`;

export const Label = styled.label`
  font-family: Rubik;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  color: #000;
`;

export const ProgressBar = styled.div`
  width: 100%;
  background-color: rgba(43, 58, 102, 0.5);
  border-radius: 3px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, .2);
`;
export const ProgressFill = styled.div`
  height: 16px;
  background-color: #2b3a66;
  border-radius: 3px;
  transition: width 500ms ease-in-out;
  display: flex;
  justify-content: end;
  align-items: center;
`;

export const Value = styled.span`
 font-family: Rubik;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
  margin-right: 6px;
`;